import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface ModalProps {
  onSubmit: () => void
  onClose: () => void
}

const UninstallApplicationModal = ({ onSubmit, onClose }: ModalProps) => {
  return (
    <Modal
      title={i18n.t('software_management.software_setups.actions.uninstall.title')}
      description={i18n.t('software_management.software_setups.actions.uninstall.description')}
      illustration="alert"
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" gap="s16">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('common.confirm')}</Button>
        </Box>
      }
      onClose={onClose}
    />
  )
}

export default UninstallApplicationModal
